import { ActiveMenusResponse } from './types'

export const activeMenusResponseValidator = (response: ActiveMenusResponse) => {
  if (response?.data?.length > 0) {
    const isValid = response.data.every((menuRecord) => {
      const menuKeys = Object.keys(menuRecord || {})
      const menuLevelAllKeysArePresent = ['id', 'attributes'].every((item) =>
        menuKeys.includes(item),
      )

      const { attributes } = menuRecord
      const attributesKeys = Object.keys(attributes || {})
      const attributeLevelKeysArePresent = ['core_menu_id', 'period', 'starts_at', 'ends_at'].every(
        (item) => attributesKeys.includes(item),
      )

      const periodLevelKeysArePresent = Object.keys(attributes?.period || {}).includes(
        'core_period_id',
      )

      return menuLevelAllKeysArePresent && attributeLevelKeysArePresent && periodLevelKeysArePresent
    })

    if (!isValid) {
      throw new Error('The content of the Active Menus end point is of invalid shape')
    }

    return response
  }

  throw new Error('The Active Menus endpoint returned unexpected data')
}
